export default __webpack_public_path__ + "static/media/graphic-group.54c74b15.png";